import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, Label, Button } from "@/components/ui";
import { toast } from "sonner";

// "Take it back" — lets a family revoke a published testimonial instantly.
export function FeedbackSettings() {
  const [items, setItems] = useState(null);
  const load = () => api.feedbackMine().then((r) => setItems(r.items || [])).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  if (!items || items.length === 0) return null;

  const withdraw = async (id) => {
    try { await api.feedbackWithdraw(id); toast.success("Removed — we won't share it."); load(); }
    catch { toast.error("Could not update. Please try again."); }
  };

  return (
    <Card className="mt-5" data-testid="feedback-settings">
      <Label>Your feedback</Label>
      <div className="mt-3 space-y-3">
        {items.map((it) => (
          <div key={it.id} className="border border-line rounded-lg p-3" data-testid={`feedback-item-${it.id}`}>
            <p className="text-sm text-ink">{it.answer || "—"}</p>
            <div className="flex items-center justify-between mt-2 gap-3">
              <span className="text-xs text-subtle">
                {it.shareable ? `Shared as a testimonial (${it.consent})` : "Kept private"}
              </span>
              {it.can_withdraw && (
                <Button variant="ghost" data-testid={`feedback-withdraw-${it.id}`} onClick={() => withdraw(it.id)}>
                  Take it back
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
